import {router} from '../router';
import vars from '../vars';

let currentQuestion = 1;

let gendor;

let answers = [];

const answersVariants = [
	{
		variants: [2, 1, 1],
		result: 1,
	},
	{
		variants: [2, 2, 1],
		result: 2,
	},
	{
		variants: [2, 1, 2],
		result: 3,
	},
	{
		variants: [2, 2, 2],
		result: 4,
	},
	{
		variants: [1, 1, 1],
		result: 5,
	},
	{
		variants: [1, 2, 1],
		result: 6,
	},
	{
		variants: [1, 1, 2],
		result: 7,
	},
	{
		variants: [1, 2, 2],
		result: 8,
	},
];

function testStart() {
	currentQuestion = 1;
	gendor = undefined;

	$('.test__option[data-option="1"]').removeClass('is-hidden');
}

testStart();

function nextQuestion(currentGendor) {
	let $prevLeftOption = $(`.test__option[data-option="${currentQuestion - 1}"][data-answer="1"]`);

	let $prevRightOption = $(`.test__option[data-option="${currentQuestion - 1}"][data-answer="2"]`);

	let $nextLeftOption;

	let $nextRightOption;

	if (currentQuestion > 1 && vars.$pageTestCounter.hasClass('is-hidden')) {
		new TimelineMax({
			onStart() {
				vars.$pageTestCounter.removeClass('is-hidden');
			},
			onComplete() {
				vars.$pageTestDescription.addClass('is-hidden');

				TweenMax.set(vars.$pageTestDescription, {clearProps: 'all'});
			},
		})
			.to(vars.$pageTestDescription, 0.3, {
				opacity: 0,
			})
			.from(vars.$pageTestCounter, 0.3, {
				opacity: 0,
				clearProps: 'all',
			});
	}

	if (currentGendor === undefined) {
		$nextLeftOption = $(`.test__option[data-option="${currentQuestion}"][data-answer="1"]`);
		$nextRightOption = $(`.test__option[data-option="${currentQuestion}"][data-answer="2"]`);
	} else {
		$nextLeftOption = $(`.test__option[data-option="${currentQuestion}"][data-answer="1"][data-gendor="${currentGendor}"]`);
		$nextRightOption = $(`.test__option[data-option="${currentQuestion}"][data-answer="2"][data-gendor="${currentGendor}"]`);
	}

	new TimelineMax({
		onStart() {
			$(`.test__counter__item[data-item="${currentQuestion - 1}"]`).addClass('is-active');
			$('.test__option').addClass('not-active');
			if (currentGendor === undefined) {
				$(`.test__option[data-option="${currentQuestion}"]`).removeClass('is-hidden');
			} else {
				$(`.test__option[data-option="${currentQuestion}"][data-gendor="${currentGendor}"]`).removeClass('is-hidden');
			}
		},
		onComplete() {
			$(`.test__option[data-option="${currentQuestion - 1}"]`).addClass('is-hidden');
			$('.test__option').removeClass('not-active');
			TweenMax.set([$prevLeftOption, $prevRightOption], {clearProps: 'all'});
			ga('send', 'event', 'test', `question show ${currentQuestion}`, 'Выберите один из вариантов');
		},
	})
		.to($prevLeftOption, 0.5, {
			autoAlpha: 0,
			x: -100,
		})
		.to($prevRightOption, 0.5, {
			autoAlpha: 0,
			x: 100,
		}, 0)
		.from($nextLeftOption, 0.5, {
			autoAlpha: 0,
			x: -100,
			clearProps: 'all',
		})
		.from($nextRightOption, 0.5, {
			autoAlpha: 0,
			x: 100,
			clearProps: 'all',
		}, 0.5);
}

export function testRestart() {
	answers = [];
	currentQuestion = 1;

	vars.$pageTestDescription.removeClass('is-hidden');
	vars.$pageTestCounter.addClass('is-hidden');

	$('.test__option').addClass('is-hidden').removeClass('not-active');
	$('.test__counter__item').removeClass('is-active');
}

$('.test__option').on('click', (e) => {
	currentQuestion++;
	answers.push($(e.currentTarget).data('answer'));

	if ($(e.currentTarget).data('option') === 3) {
		let id;

		answersVariants.forEach(({variants, result}) => {
			if (variants.toString() === answers.toString()) {
				id = result;
			}
		});

		router.navigate(`/result/${id}`);

		return false;
	}

	if ($(e.currentTarget).data('option') === 2) {
		if (answers[0] === 1) {
			gendor = 'male';
		} else {
			gendor = 'female';
		}
	}

	nextQuestion(gendor);

	return true;
});

if (innerWidth > 1024) {
	$(document).on('scroll', () => {
		if (vars.$html.data('page') === 'result') {
			let $result = $('.result').not('.is-hidden');

			let $resultTextblock = $result.find('.result__textblock');

			let $resultMore = $result.find('.result__more');

			if ($(document).scrollTop() >= $resultTextblock.offset().top - 50) {
				if (
					!$resultMore.hasClass('is-fixed') &&
					$(document).scrollTop() < $resultTextblock.offset().top - 50 +
					$resultTextblock.height() - $resultMore.outerHeight()
				) {
					$resultMore.addClass('is-fixed').removeClass('is-bottom');
				}

				if (
					!$resultMore.hasClass('is-bottom') &&
					$(document).scrollTop() >= $resultTextblock.offset().top - 50 +
					$resultTextblock.height() - $resultMore.outerHeight()
				) {
					$resultMore.addClass('is-bottom').removeClass('is-fixed');
				}
			} else {
				$resultMore.removeClass('is-fixed');
			}
		}
	});
}
